import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RaDashboardService {
  constructor() {
  }
  loadedScripts: string[] = [];
  widgets = [
    {
      dashboardId: '1',
      id: '1',
      customTag: 'gallery-data',
      scriptUrl: 'assets/gallery.bundle.js',
      title: 'Gallery'
    },
    {
      dashboardId: '1',
      id: '2',
      customTag: 'emp-details',
      scriptUrl: 'assets/empdetails.bundle.js',
      title: 'Employee Details'
    },
    {
      dashboardId: '1',
      id: '3',
      customTag: 'emp-details',
      scriptUrl: 'assets/empdetails.bundle.js',
      title: 'Employees'
    }
  ];


  /// To retrieve the list of widgets based on dashboard id
  public getWidgetsbyDashboardID(dashboardId: number) {
    return this.widgets;
    // to be developed - api access
  }

  /// To retrieve widget details like position in the dashboard, script path, custom tag etc.
  public getWidgetInformation(widgetId: string) {
    var index=Math.floor(Math.random() * Math.floor(2));
    return this.widgets[index];
    // to be developed - api access
  }

  /// To load external scripts in the dom
  loadExternalScript(scriptPath): void {
    if (this.loadedScripts.indexOf(scriptPath) == -1) {
      const script = document.createElement('script');
      script.src = scriptPath;
      document.body.appendChild(script);
      this.loadedScripts.push(scriptPath);
    }
  }
}
